import React from 'react';
import { useDeletePrioritySchemeController } from '../controllers/delete-priority-scheme';
import { useFilters } from '../controllers/filters';
import { usePrioritySchemesPageController } from '../controllers/priority-schemes-page';
import { usePrioritySchemesService } from '../services/priority-schemes-page';
import { PrioritySchemesPageView } from './main';

export const PrioritySchemesPage = () => {
	const { filters, setSchemeName, setPriorityIdsFilter } = useFilters();
	const prioritySchemesServiceResults = usePrioritySchemesService();
	const prioritySchemesPageViewProps = usePrioritySchemesPageController(
		prioritySchemesServiceResults,
	);

	const { onDeleteSchemeSuccess } = prioritySchemesPageViewProps;
	const deletePrioritySchemeProps = useDeletePrioritySchemeController(onDeleteSchemeSuccess);

	return (
		<PrioritySchemesPageView
			{...prioritySchemesPageViewProps}
			{...deletePrioritySchemeProps}
			filters={filters}
			setSelectedPriorityIds={setPriorityIdsFilter}
			setSchemeName={setSchemeName}
		/>
	);
};

export default PrioritySchemesPage;
